<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0">Entrada y Salida de Productos</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><router-link :to="{ name:'dashboard'}">Home</router-link></li>
            <li class="breadcrumb-item active">Entrada Salida</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <div class="card card-primary card-outline">
      <div class="card-body">
          <div class="row">
            <div class="col-sm-10">
                <div class="input-group" @keyup.enter="listarMovimientoStock('',prodbuscar,inout,fecha)">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-md btn-default">
                        Producto
                        </button>
                    </div>
                    <input type="text" v-model="prodbuscar" class="form-control" placeholder="Nombre de producto">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-md btn-default">
                        E/S
                        </button>
                    </div>
                    <select name="" id="" class="form-control" v-model="inout">
                        <option value="TODOS">TODOS</option>
                        <option value="ENTRADA">ENTRADA</option>
                        <option value="SALIDA">SALIDA</option>
                    </select>
                    <div class="input-group-append">
                        <button type="button" class="btn btn-md btn-default">
                        Fecha
                        </button>
                    </div>
                    <input type="date" v-model="fecha" class="form-control form-control-md" >
                    <div class="input-group-append">
                        <button type="button" class="btn btn-md btn-info" @click="listarMovimientoStock(1,prodbuscar,inout,fecha)">
                            <i class="fa fa-search"></i> Buscar
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-sm-2 text-right">
                <button class="btn btn-success btn-flat" @click="exportarExcel()">Excel</button>
              </div>
          </div>
          <br>
          <div class="table-responsive">
              <table class="table table-bordered table-sm table-striped">
                  <thead class="bg-primary">
                      <tr>
                          
                          <th>Producto</th>
                          <th>Modelo | Serie</th>
                          <th>Fecha venc.</th>
                          <th>Cantidad</th>
                          <th>Tipo de Unidad</th>
                          <th>Movimiento</th>
                          <th>Fecha y Hora</th>
                          <th>Observacion</th>
                          <th>Almacen</th>
                      </tr>
                  </thead>
                  <tbody>
                     <tr v-for="ve in arrayMovStock" :key="ve.id">
                        
                       <td>{{ve.producto}}</td>
                       <td>{{ve.modelo}} | {{ve.serie}}</td>
                       <td>{{fechaFormateada(ve.fvencimiento)}}</td>
                       <td>{{ve.cantidad}}</td>
                       <td>{{ve.unidadMedida}}</td>
                       <td>{{ve.tipoMovimiento}}</td>
                       <td>{{ve.fecha}}</td>
                       <td>{{ve.observacion}}</td>
                       <td>{{ve.almacen}}</td>
                     </tr>
                  </tbody>
              </table>
          </div>
                      <!-- Agrega el paginador aquí -->
                      <div class="row">
                        <div class="col-sm-6">
                            <span>Registros: {{ totalRegistros }}</span>
                        </div>
                        <div class="col-sm-6">
                            <ul class="pagination pagination-sm justify-content-end">
                                <li class="page-item"  :class="{disabled: isOnFirstPage}">
                                    <a class="page-link" @click="goToFirstPage" :disabled="isOnFirstPage">Primero</a>
                                </li>
                                <li class="page-item"  :class="{disabled: isOnFirstPage}">
                                    <a class="page-link" @click="goToPreviousPage" >Anterior</a>
                                </li>
                                <li class="page-item" :class="{ active: currentPage === page }" v-for="page in visiblePages" :key="page">
                                    <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                                </li>
                                <li class="page-item" :class="{disabled: isOnLastPage}">
                                    <a class="page-link" @click="goToNextPage" >Siguiente</a>
                                </li>
                                <li class="page-item" :class="{disabled: isOnLastPage}">
                                    <a class="page-link" @click="goToLastPage" :disabled="isOnLastPage">Último</a>
                                </li>
                            </ul>
                        </div>
                    </div>
           <!-- Agrega el paginador aquí -->
          
      </div>      

  </div><!-- /.card -->

</template>

<script>
    export default{
      data(){
          return{
            id:'',
            arrayMovStock: [],
            ventas:'',
            ncreditos:'',
            idEmpresa:'',
            rucEmpresa:'',

            prodbuscar:'',
            inout:'TODOS',
            fecha:'',
            
            currentPage: 1,
            totalPages: 0,
            listporPage: 15, // coincide con el paginado DRF
            visiblePages: [], // Páginas visibles en el paginado
            totalPagesToShow: 5, // Cantidad de páginas visibles en el paginado
            totalRegistros:0,

          }
      },
      computed: {
        isOnFirstPage() {
          return this.currentPage === 1;
          },
          isOnLastPage() {
          return this.currentPage === this.totalPages;
          },
      },
      methods:{
        updateVisiblePages() {
              const halfTotalPagesToShow = Math.floor(this.totalPagesToShow / 2);

              let startPage = Math.max(this.currentPage - halfTotalPagesToShow, 1);
              let endPage = Math.min(this.currentPage + halfTotalPagesToShow, this.totalPages);

              if (this.totalPages > this.totalPagesToShow) {
                  // Si el número de páginas es mayor que el total de páginas a mostrar, ajustamos los extremos
                  if (endPage === this.totalPages) {
                  startPage = Math.max(endPage - this.totalPagesToShow + 1, 1);
                  } else if (startPage === 1) {
                  endPage = Math.min(startPage + this.totalPagesToShow - 1, this.totalPages);
                  }
              }

              this.visiblePages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
          },
          goToPage(pageNumber) {
              // Cambiar la página actual al número de página seleccionado
              this.currentPage = pageNumber;
              // Llamar al método para obtener los datos de la página seleccionada
              this.listarMovimientoStock(pageNumber,'','','');
          },
          goToPreviousPage() {
              if (this.currentPage > 1) {
                  this.currentPage -= 1;
                  this.listarMovimientoStock(this.currentPage,'','','');
              }
          },
          goToNextPage() {
              if (this.currentPage < this.totalPages) {
                  this.currentPage += 1;
                  this.listarMovimientoStock(this.currentPage,'','','');
              }
          },
          goToFirstPage() {
              if (this.currentPage !== 1) {
                  this.currentPage = 1;
                  this.listarMovimientoStock(this.currentPage,'','','');
              }
          },

          goToLastPage() {
              if (this.currentPage !== this.totalPages) {
                  this.currentPage = this.totalPages;
                  this.listarMovimientoStock(this.currentPage,'','','');
              }
          },

          listarMovimientoStock(pageNumber=1,prodbuscar,inout,fecha){
              let me = this
              this.$axios.get(`apinventario/entradasalida/?page=${pageNumber}&prodbuscar=${prodbuscar}&inout=${inout}&fecha=${fecha}`)
              .then(function(response){
                  me.arrayMovStock = response.data.results
                  me.currentPage = pageNumber
                  me.totalPages = Math.ceil(response.data.count / me.listporPage)
                  me.totalRegistros = response.data.count
                  me.updateVisiblePages()
                  if(me.arrayMovStock.length < 1){me.$toastr.info('No se halló resultados', 'Intente con otra fecha')}
              })
          },
          
        exportarExcel(){
          if(this.arrayMovStock.length > 0){
            window.open(`impresiones/entradasalida/${this.prodbuscar || 'null'}/${this.inout || 'null'}/${this.fecha || 'null'}/${this.idEmpresa}/`, '_blank')
          }else{
            this.$toastr.error('No hay registros a exportar', 'Error!')
          }
        },
        fechaFormateada(fecha) {
            if(fecha){
                const partes = fecha.split('-');
                return `${partes[2]}/${partes[1]}/${partes[0]}`;
            }else{
                return ''
            }
        },
      },
      watch: {
        currentPage() { // Actualizar las páginas visibles cuando se cambia la página actual
          this.updateVisiblePages()
          },
          totalPages() { // Actualizar las páginas visibles cuando se actualiza el número total de páginas
          this.updateVisiblePages()
          },
      },
      mounted(){
          this.listarMovimientoStock(1,this.prodbuscar,this.inout,this.fecha)
          this.updateVisiblePages()
          this.idEmpresa = localStorage.getItem('idEmpresa')
          this.rucEmpresa = localStorage.getItem('rucEmpresa')          
      }
  }
</script>

<style scoped>.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
}
.modal-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content{
  width: 40%;
  background-color: white;
  margin-top: 100px;
}
.tooltip-btn {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

/* Estilo del tooltip */
.tooltip-btn::before {
  content: attr(data-tooltip);
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 1px 5px;
  
  white-space: nowrap;
  border-radius: 4px;
  top: -15px; /* Ajusta la posición vertical según tus necesidades */
  left: 80%;
  transform: translateX(-50%);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

/* Mostrar el tooltip al hacer hover */
.tooltip-btn:hover::before {
  opacity: 1;
  visibility: visible;
}
</style>